import React from "react";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { CssBaseline, Box } from "@mui/material";
import { useTheme as useCustomTheme } from "./context/ThemeContext";
import AppRouter from "./router/AppRouter";
import theme from "./theme";

/**
 * Componente principal de la aplicación SGCM
 *
 * Propósito:
 * - Integrar el tema de Material-UI con el contexto personalizado
 * - Proporcionar estilos globales y normalización (CssBaseline)
 * - Renderizar el router principal de la aplicación
 *
 * Arquitectura:
 * - Los providers (ThemeProvider, AuthProvider, NotificationProvider, etc.) están en main.jsx
 * - Este componente consume esos contextos y renderiza la UI
 * - El router maneja toda la navegación y rutas protegidas
 * - Las notificaciones son manejadas automáticamente por notistack en NotificationProvider
 */
const App = () => {
  const { isDarkMode } = useCustomTheme();

  return (
    <MuiThemeProvider theme={theme}>
      {/* CssBaseline normaliza estilos entre navegadores */}
      <CssBaseline />

      {/* Contenedor principal de la aplicación */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          backgroundColor: "background.default",
          color: "text.primary",
          transition: "background-color 0.3s ease",
        }}>
        {/* Router principal con todas las rutas */}
        <AppRouter />
      </Box>
    </MuiThemeProvider>
  );
};

export default App;
